import { z } from 'my-zod'
import { operatorsModel } from './operators-model'

export const operatorShortView = operatorsModel.pick({
  businessName: true,
  id: true,
  businessPhone: true,
  businessEmail: true
})

export type operatorShortView = z.infer<typeof operatorShortView>
